// src/store/slices/feedbackSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import feedbackApi from 'api/feedbackApi';

export const fetchFeedbacks = createAsyncThunk(
  'feedback/fetchAll',
  async ({ page = 1, pageSize = 10, search = '' }, { rejectWithValue }) => {
    try {
      const res = await feedbackApi.getAll(page, pageSize, search);
      return res;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load feedbacks');
    }
  }
);

export const markFeedbackRead = createAsyncThunk(
  'feedback/markRead',
  async ({ id, is_read }, { rejectWithValue }) => {
    try {
      const res = await feedbackApi.markRead(id, is_read);
      return res;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to update');
    }
  }
);

export const deleteFeedback = createAsyncThunk(
  'feedback/delete',
  async (id, { rejectWithValue }) => {
    try {
      await feedbackApi.delete(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to delete');
    }
  }
);

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState: {
    feedbacks: [],
    pagination: { count: 0, page_size: 10 },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeedbacks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchFeedbacks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.feedbacks = action.payload.data || [];
        state.pagination = action.payload.pagination || {};
      })
      .addCase(fetchFeedbacks.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(markFeedbackRead.fulfilled, (state, action) => {
        const updated = action.payload;
        const idx = state.feedbacks.findIndex(f => f.id === updated.id);
        if (idx !== -1) state.feedbacks[idx] = updated;
      })

      .addCase(deleteFeedback.fulfilled, (state, action) => {
        state.feedbacks = state.feedbacks.filter(f => f.id !== action.payload);
        state.pagination.count = Math.max(0, state.pagination.count - 1);
      });
  },
});

export const { clearError } = feedbackSlice.actions;
export default feedbackSlice.reducer;